enum VRAI_FAUX {
  true = "Vrai",
  false = "Faux",
}
export default VRAI_FAUX;
